import {lazy} from '@aboutyou/lazy-imports';

export const AboutUs = lazy(
  () => import('./AboutUs.eager').then(mod => ({default: mod.AboutUs})),
  {
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
